import {NoteModalConfig} from "../types/note-page-modals-config.types";
import {
  NoteChangePriceModalComponent
} from "../components/modals/note-change-price-modal/note-change-price-modal.component";
import {KeyTestsModalComponent} from "../components/modals/key-tests-modal/key-tests-modal.component";

const noteFieldConfig = {
  noteChangePrice: { component: NoteChangePriceModalComponent, width: '460px' },
  advertisementKey: { component: KeyTestsModalComponent, width: '600px' },
} as const;

export const noteModalConfig: Record<string, NoteModalConfig> =
  Object.fromEntries(
    Object.entries(noteFieldConfig).map(([fieldName, config]) => [
      fieldName,
      {
        ...config,
        fieldName
      }
    ])
  );
